var vm = new Vue({
  el: '#register-page',
  data() {
    return {
      greeting: "Hello!",
      pass1: "",
      pass2: "",
      focusedElementId: "register_password", // Track the focused element's ID
      passInputEverFocused: false,
      pwInputType: "password",
      preselectClass: localStorage.getItem('preselectClass'),
      preselectSpec: localStorage.getItem('preselectSpec'),
      preselectProvider: localStorage.getItem('preselectProvider'),
      preselectLocale: localStorage.getItem('cc') || "uk"
    }
  },
  computed: {
    test1() {
      /* Has the user entered both upper and lowercase characters? */
      const hasUpperCase = /[A-Z]/.test(this.pass1);
      const hasLowerCase = /[a-z]/.test(this.pass1);
      return hasUpperCase && hasLowerCase;
    },
    test2() {
      /* Has the user entered at least one number or symbol? */
      /* Symbol range borrowed from utilities.js (A name-pattern map). */
      const hasNumber = /[0-9]/.test(this.pass1);
      const hasSymbol = /[\u0021-\u002f\u003a-\u0040\u005b-\u0060\u007b-\u007e\u0080-\uffff]/.test(this.pass1);
      return hasNumber || hasSymbol;
    },
    test3() {
      /* Has the user entered at least eight characters? */
      return this.pass1.length >= 8;
    },
    test4() {
      /* Do the passwords match? */
      if(this.pass2.length) {
        return this.pass1 === this.pass2;
      }
    },
    goRed() {
      return (
        (!this.pass1.length && this.passInputEverFocused && this.focusedElementId !== 'register_password') ||
        this.pass1.length &&
        this.focusedElementId !== 'register_password' &&
        (!this.test1 || !this.test2 || !this.test3)
      )
    },
  },
  methods: {
    getFocused() {
      // Listen for focus events to update the focusedElementId
      document.addEventListener('focusin', (event) => {
        this.focusedElementId = event.target.id;
      });

      // Listen for blur events to reset the focusedElementId
      document.addEventListener('focusout', () => {
        this.focusedElementId = null;
      });
    },
    itWasFocused() {
      if(!this.pass1.length) {
        this.pass1 = "a";
        this.pass1 = "";
      }
      this.passInputEverFocused = true;
    },
    togglePeek() {
      if(this.pwInputType === "password") {
        this.pwInputType = "text";
      } else {
        this.pwInputType = "password";
      }
    },
    setUp() {
        const popOver = document.getElementById("pop-over");
        const main = document.querySelector(".main");
        const closePopOver = document.querySelector(".close");

        closePopOver.onclick = function() {
          popOver.style.display = "none";
          main.style.display = 'block'
        }


        document.querySelector("#register_password").title = ExtendedPasswordValidator.reason;
        document.querySelector("#register_password").pattern = ExtendedPasswordValidator.comboPattern.source;
        $(function() {
          var pass1 = $('#register_password');
          var pass2 = $('#register_check_password');
          var registerForm = $('#new-customer-form');
          var terms = $('#terms-and-conditions')[0];

          registerForm.on("submit", function (event) {
            if( !looks_like_emailaddress($('#register_email').val()) ){
              ShowNotification.fail("The email address does not look valid");
            }
            if (pass1.val() != pass2.val()) {
              ShowNotification.fail("Your passwords did not match.");
              return false;
            } else if ( terms.checked != true ) {
              ShowNotification.fail("You must agree to our Terms and Conditions.");
              return false;
            } else if ( !looks_like_emailaddress($('#register_email').val()) ) {
              ShowNotification.fail("The email address does not look valid");
              return false;
            } else if(!ExtendedPasswordValidator.forPassword(pass1.val()).valid) {
              ShowNotification.fail("The password does not look valid.  Min length is 8 characters and must contain a good mix of numbers, letters and non alpha numberic characters (eg .!\"£$%^&*()_=+-[];{}:@~#<>?,/\|");
              return false;
            } else {
              return true;
            }
          });

          const urlParams = new URLSearchParams(window.location.search);
          console.log(urlParams);
          switch( urlParams.get('r') ){
              case 'order-vps':
                  window.localStorage.setItem('signupRedirect', 'order-vps');
                  break;
              default:
                  window.localStorage.setItem('signupRedirect', 'build-server');
          }
        });
        const urlParams = new URLSearchParams(window.location.search);
        const pc = urlParams.get('pc');
        const ps = urlParams.get('ps');
        const pp = urlParams.get('pp');
        const cc = urlParams.get('cc');
        const validSpecs = [
          '20icloud', 'wordpress', 'magento', 'woocommerce', 'laravel',
          'joomla', 'nodejs', 'netcore', 'agency', 'gcp', 'aws', 'managed'
        ];
        const validPC = validSpecs.includes(pc) ? pc : 'default';

        localStorage.removeItem('preselectClass');
        localStorage.setItem('preselectClass', validPC);

        localStorage.removeItem('preselectSpec');
        localStorage.setItem('preselectSpec', ps);

        localStorage.removeItem('preselectProvider');
        localStorage.setItem('preselectProvider', pp);

        localStorage.removeItem('preselectLocale');
        localStorage.setItem('preselectLocale', cc);
        this.preselectClass = validPC;
        this.preselectSpec = ps;
        this.preselectProvider = pp;
        this.preselectLocale = cc;
      }
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('unt')) {
      ShowNotification.fail('This username is already taken. Please try another one.');
    }

    // Call the getFocused method when the document is clicked
    document.addEventListener('click', () => {
      this.getFocused();
    });

    let tdPrefs = localStorage.getItem('dateTimePreferences')
    if (tdPrefs && tdPrefs.length) {
      tdPrefs = JSON.parse(tdPrefs)
    }
    var d = new Date();
    var n = tdPrefs && tdPrefs.timezone ? d.getHours() + (parseInt(tdPrefs.timezone.offset, 10)) : d.getHours();
    switch(n) {
      case 5:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
        this.greeting = "Good morning!";
        break;
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
        this.greeting = "Good afternoon!";
        break;
      default:
        this.greeting = "Good evening!";
    }

    this.$nextTick( () => {
        this.setUp();
    } );
  }
})
